import React, { useState, useEffect } from "react";
import styles from "../../component/Landing_page/Landing_page.module.css"; 
import { Link } from "react-router-dom";
import Contactus from './Contact_Us/Contactus'
import Servicespage from './Services_Page/Servicespage'
import Aboutus from './About_Us/Aboutus'

export default function Landing_Page() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const cards = [
        {
            title: "Real-Time Tracking",
            description: "Monitor inventory and sales in real-time with instant updates. Monitor inventory and sales in real-time with instant updates.",
        },
        {
            title: "Barcode Integration",
            description: "Easily scan and manage your stock with barcode-enabled features. Easily scan and manage your stock with barcode-enabled features.",
        },
        {
            title: "Analytics Dashboard",
            description: "Get in-depth insights and reports to make data-driven decisions. Get in-depth insights and reports to make data-driven decisions.",
        },
        {
            title: "Multi-Store Management",
            description: "Manage multiple stores or franchises from a single interface. Manage multiple stores or franchises from a single interface.",
        },
    ];

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === cards.length - 1 ? 0 : prevIndex + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? cards.length - 1 : prevIndex - 1));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex === cards.length - 1 ? 0 : prevIndex + 1));
        }, 5000);
        return () => clearInterval(interval);
    }, [cards.length]);

   

    return (
        <div>
            <div className={`container-fluid ${styles.landingMain}`}  id="HOME_SECTION" >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        {/* Left Content */}
                        <div className={`col-md-6 ${styles.landingContent1}`}>
                            <h2>Enhanced, Efficient & Robust</h2>
                            <h3>
                                Cloud-Based
                                <span style={{ color: "#4fa4ce" }}> POS Solutions </span>
                            </h3>
                            <h3>For Retail, Supermarket And Multi-Store/Franchise</h3>
                            <p>
                                Explore the advanced cloud-based point of sale (POS), billing, CRM,
                                <br />
                                e-commerce solution designed to revolutionize your retail experience.
                            </p>
                            <Link to={'/Sign_up'} className={styles.customButton}> <i class="fas fa-user-plus"></i>&nbsp;
                            Register Now </Link>
                        </div>
                        {/* Right Video Section */}
                        <div className={`col-md-6 mt-4 ${styles.landingContent1_2}`}>
                            <div className={styles.videoContainer}>
                               <img src="images\home_img.jpg" alt="" />
                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Aboutus />
            <Servicespage />
            <Contactus />

           
        </div>
    );
}
